import React, { useState } from "react";
import "./ToggleButton.css";

const ToggleButton = ({ label, setValues }) => {
  const [isChecked, setIsChecked] = useState(false);

  const handleToggle = () => {
    const newValue = isChecked ? 0 : 1; // Toggle between 0 and 1
    setValues(newValue); // Set the new value in the parent component
    setIsChecked(!isChecked); // Toggle the state
  };

  return (
    <div className="toggleContainer">
      <label className="toggleButton">
        <input type="checkbox" checked={isChecked} onChange={handleToggle} />
        <span className="slider round"></span>
      </label>
      <span className="labelText">{label}</span>
    </div>
  );
};

export default ToggleButton;













//CODE FOR ACTIVE TOGGLE WITH DISABLED OPTION
// import React, { useState, useEffect } from "react";
// import "./ToggleButton.css";

// const ToggleButton = ({ 
//   label = "Enable", 
//   initialValue = false, 
//   disabled = false,
//   setValues 
// }) => {
//   const [isChecked, setIsChecked] = useState(initialValue === 1 || initialValue === true);

//   // Sync with initialValue prop changes
//   useEffect(() => {
//     setIsChecked(initialValue === 1 || initialValue === true);
//   }, [initialValue]);

//   const handleToggle = () => {
//     if (disabled) return; // Prevent toggle if disabled
    
//     const newValue = isChecked ? 0 : 1;
//     setValues(newValue); // Pass 0/1 to parent
//     setIsChecked(!isChecked); // Update local state
//   };

//   return (
//     <div className="toggleContainer">
//       <label className={`toggleButton ${disabled ? 'disabled' : ''}`}>
//         <input 
//           type="checkbox" 
//           checked={isChecked} 
//           onChange={handleToggle}
//           disabled={disabled}
//         />
//         <span className="slider round"></span>
//       </label>
//       <span className="labelText">{label}</span>
//     </div>
//   );
// };

// export default ToggleButton;
